import Gateway from "@phoenixreisen/gateway";
import DateTime from "date-and-time";
import Page from "./layout/layout.m";
import Model from "./model";
import m from "mithril";
import "date-and-time/locale/de";
import "./index.scss";
(() => {
    const { env } = process;
    DateTime.locale("de");
    Gateway.setApiErrorUrl(env.CATALOG_FALLBACK);
    Gateway.setApiUrl(`${env.GATEWAY}/call-json-service`);
    m.route(document.body.querySelector("#root"), "/", {
        "/": {
            onmatch: () => {
                location.href = env.API_ERROR;
            },
        },
        "/:key": {
            onmatch: () => Model.getWebtexte(),
            render: () => [m(Page, { key: m.route.param("key") })],
        },
    });
})();
